// La fiche d'une personnalité (15 octobre 2026) : la page, son en-tête, son parcours.
// Jamais de genre deviné : « en » plutôt que « d'elle » ou « de lui ».
export default {
  titre: 'Personnalités',
  chargement: 'Chargement de la fiche…',
  entete: {
    retour: 'Personnalités',
    nonSuivie: 'Pas suivie',
    chaqueJour: 'Écoutée chaque jour',
    premiere: 'Première écoute en cours',
    ecouteeCeMatin: 'Écoutée chaque jour · dernière écoute aujourd’hui à {heure}',
    ecouteeLe: 'Écoutée chaque jour · dernière écoute le {quand} à {heure}',
  },
  onglets: {
    aria: 'La fiche',
    jour: 'Aujourd’hui',
    citations: 'Citations',
    personas: 'Ceux qui en parlent',
    sonar: 'Sonar',
    zeus: 'Hermès',
    positions: 'Positions et parcours',
  },
  premiere: {
    titre: 'Première écoute en cours',
    texte: 'Orion lit la semaine écoulée : ce qui a été dit, par qui, où et quand. La fiche se complète d’elle-même dans quelques minutes.',
  },
  nonSuivie: {
    titre: 'L’écouter chaque jour',
    texte: 'Suivre cette personnalité déclenche une écoute quotidienne : ce qui se dit, ses propres mots, chaque citation avec sa source, ceux qui en parlent et comment ils évoluent, ses positions sujet par sujet, et une alerte quand quelque chose bouge.',
  },
  parcours: {
    titre: 'Son parcours',
    depuis: 'depuis le {debut}',
    du: 'du {debut} au {fin}',
    enCours: 'en cours',
    aucun: 'Aucun mandat connu.',
    officielle: 'Fiche officielle',
    wikidata: 'Sa fiche Wikidata',
  },
  comptes: {
    titre: 'Ses comptes',
    declare: 'déclaré',
    ajoute: 'ajouté',
    aucun: 'Aucun compte connu : Orion écoute ce qui se dit partout ailleurs.',
  },
}
